import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TableComponent from '~/components/TableComponent';
import i18n from '~/components/i18n';
import { Loader } from 'semantic-ui-react';
import { El as LayoutEl } from '~/components/Layout/style';
import CreateEditFeedProduct from './CreateEditFeedProduct';
import ClimaProgramQuery from '~/QueryHooks/ClimaProgramQuery';

const getTableColumns = () => [
  {
    name: i18n.t('Name'),
    key: 'name'
  },
  {
    name: i18n.t('Feed supplier'),
    key: 'supplierName'
  },
  {
    name: i18n.t('Agoline content'),
    key: 'agolineContent',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Status'),
    key: 'statusLabel'
  },
  {
    name: i18n.t('Actions')
  }
];

const FeedProducts: React.FC = () => {
  const { t } = useTranslation();

  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 20
  })
  const [drawer, setDrawerState] = useState({
    isVisible: false,
    id: null as number | null
  });

  const {
    isLoading: isBusy,
    data: feedProductsData,
    isFetching: isFetchingProducts,
    refetch: fetchData
  } = ClimaProgramQuery.getFeedProducts({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  });

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  const { filtered, rows } = feedProductsData ? feedProductsData : { filtered: 0, rows: [] };

  const feedProducts = rows.map(item => ({
    ...item,
    statusLabel: item.status ? t('Active') : t('Inactive')
  }));

  const actions = [
    {
      popupMessage: i18n.t('Edit'),
      type: 'icon',
      name: 'pencil',
      size: 'large',
      actionType: 'edit',
      displayedText: i18n.t('No actions')
    }
  ];

  function handleActionClick(row, type) {
    switch (type) {
      case 'edit':
        return setDrawerState({ isVisible: true, id: row?.id });
      default:
        return;
    }
  }

  function renderTable() {
    return (
      <TableComponent
        tableColumnHeaders={getTableColumns()}
        dataFiltered={dataFiltered}
        rows={feedProducts || []}
        total={filtered || 0}
        handleChangeDataFiltered={(dataFiltered) => setDataFiltered(dataFiltered)}
        handleClickAction={handleActionClick}
        animated
        isFetchingData={isFetchingProducts}
        actions={actions}
      />
    );
  }

  function renderActions() {
    return (
      <LayoutEl.PageHeaderActionButton
        onClick={() => setDrawerState({ isVisible: true, id: null })}
      >
        {t('Add')}
      </LayoutEl.PageHeaderActionButton>
    );
  }

  function renderEditCreateDrawer() {
    return (
      <CreateEditFeedProduct
        isVisible={drawer.isVisible}
        idFeedProduct={drawer.id}
        fetchData={fetchData}
        handleHiddenDrawer={() => setDrawerState({ isVisible: false, id: null })}
      />
    );
  }

  if (isBusy) {
    return <Loader active inline='centered' />;
  }

  return (
    <div>
      <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
        {renderActions()}
      </div>
      {renderEditCreateDrawer()}
      {renderTable()}
    </div>
  );
};

export default FeedProducts;
